import * as React from 'react'
import { UserVerificationForm } from './UserVerificationForm'
import { UserVerificationInfo } from './UserVerificationInfo'
import { UserVerificationResend } from './UserVerificationResend'

export const UserVerification = props => {
  const [tokenAlreadySent, setTokenAlreadySent] = React.useState(false)
  const [codePage, setCodePage] = React.useState(true)
  const [infoPage, setInfoPage] = React.useState(false)
  const [resendPage, setResendPage] = React.useState(false)

  const goToInfo = () => {
    setCodePage(false)
    setInfoPage(true)
  }

  const goToResend = () => {
    setInfoPage(false)
    setResendPage(true)
  }

  const goToVerification = () => {
    setResendPage(false)
    setInfoPage(false)
    setCodePage(true)
  }

  return (
    <div>
      {codePage && (
        <UserVerificationForm
          {...props}
          tokenAlreadySent={tokenAlreadySent}
          setTokenAlreadySent={setTokenAlreadySent}
          goToInfo={goToInfo}
        />
      )}
      {infoPage && (
        <UserVerificationInfo
          {...props}
          goToVerification={goToVerification}
          goToResend={goToResend}
        />
      )}
      {resendPage && (
        <UserVerificationResend
          {...props}
          setTokenAlreadySent={setTokenAlreadySent}
          goToVerification={goToVerification}
        />
      )}
    </div>
  )
}
